// Module
var code = `<template> <div class="page-my-account animation-slide-bottom"> <h1 class="my-account-title">\${'my-account-text' & t}</h1> <tabs class="tabs-my-account" tabs.bind="tabs" view-model.ref="tabsVM" current-tab.from-view="currentTab"></tabs> <compose view-model.bind="currentTab.vm"></compose> </div> </template>`;
// Exports
module.exports = code;